// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"sf_a vh_cv vh_jt vh_jk vh_oo vh_sk"};